import { Injectable } from "@angular/core";
import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest
} from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { Router } from "@angular/router";

@Injectable()
export class HttpInterceptorService implements HttpInterceptor {
    constructor(public router: Router) { }

    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            catchError(error => {
                console.error("error is intercept", error);
                if (error.status == 401 || error.status == 403) {
                    alert("You Session is expired. Please Login again.");
                    this.router.navigate(["/portal/handle/token"]);
                }
                return throwError(error);
            })
        );
    }
}
